import { render, staticRenderFns } from "./LandingShare.vue?vue&type=template&id=b8fe2d5e&scoped=true&"
import script from "./LandingShare.vue?vue&type=script&lang=js&"
export * from "./LandingShare.vue?vue&type=script&lang=js&"
import style0 from "./LandingShare.vue?vue&type=style&index=0&id=b8fe2d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fe2d5e",
  null
  
)

export default component.exports